import React, { useEffect, useState } from "react";
import ProposalList from "../../../components/proposal";
    import {
    insuredCorrespondenceAddConstants,
    insuredEmploymentConstants,
    insuredPermanetAddConstants,
    insuredPersonalConstants,
} from "../../../constans/insuredConstants";

const InsuredDetails = ({ insuredData }) => {
    const [personalDetailsSection, setPersonalDetailsSection] = useState(
        JSON.parse(JSON.stringify(insuredPersonalConstants))
    );
    const [employmentDetailsSection, setEmploymentDetailsSection] = useState(
        JSON.parse(JSON.stringify(insuredEmploymentConstants))
    );
    const [permanentDetailsSection, setpermanentDetailsSection] = useState(
        JSON.parse(JSON.stringify(insuredPermanetAddConstants))
    );
    const [correspondenceAddressSection, setCorrespondenceAddressSection] =
        useState(JSON.parse(JSON.stringify(insuredCorrespondenceAddConstants)));

    useEffect(() => {
        let section1 = personalDetailsSection.map((item) => {
        if (item.key === "fullname") {
            const firstName = insuredData.insuredPersonalDetail?.firstName;
            const lastName = insuredData.insuredPersonalDetail?.lastName;
            item.value = [firstName, lastName].filter(Boolean).join(" ").trim();
        } else if (item.key === "occupationType") {
            item.value = insuredData.insuredEmploymentDetail[item.key];
        } else if (item.key === "identityType" || item.key === "identityNumber") {
            item.value = insuredData?.identityDetail?.[item.key];
        } else if (item.key === "residentialStatus") {
            item.value = insuredData.nationalityDetail[item.key];
        } else if (
            item.key === "panNumber" &&
            !insuredData.insuredPersonalDetail.submitForm60
        ) {
            item.value = insuredData?.panDetail?.[item.key];
        } else if (item.key === "submitForm60") {
            item.value = insuredData.insuredPersonalDetail.submitForm60
            ? "YES"
            : "NO";
        } else if (
            [
            "panApplied",
            "assessedToTax",
            "otherThanAgriculturalIncome",
            "agriculturalIncome",
            "dateOfApplication",
            "acknowledgementNumber",
            "reasonForNotHavingPanOrIGNumber",
            "circleOfLastReturnField",
            ].includes(item.key)
        ) {
            if (!insuredData.insuredPersonalDetail.submitForm60) {
            item.show = false;
            } else {
            item.show = true;
            if (
                item.key === "otherThanAgriculturalIncome" ||
                item.key === "agriculturalIncome"
            ) {
                insuredData.panDetail.panApplied
                ? (item.show = false)
                : (item.show = true);
            } else if (
                item.key === "dateOfApplication" ||
                item.key === "acknowledgementNumber"
            ) {
                !insuredData.panDetail.panApplied
                ? (item.show = false)
                : (item.show = true);
            } else if (
                item.key === "reasonForNotHavingPanOrIGNumber" ||
                item.key === "circleOfLastReturnField"
            ) {
                !insuredData.panDetail.assessedToTax
                ? (item.show = false)
                : (item.show = true);
            }
            if (
                item.key === "agriculturalIncome" ||
                item.key === "otherThanAgriculturalIncome"
            ) {
                item.value = insuredData.insuredPersonalDetail[item.key];
            } else if (
                item.key === "panApplied" ||
                item.key === "assessedToTax"
            ) {
                item.value = insuredData.panDetail[item.key] ? "YES" : "NO";
            } else {
                item.value = insuredData.panDetail[item.key];
            }
            }
        } else {
            item.value = insuredData.insuredPersonalDetail[item.key];
        }
        return item;
        });
        setPersonalDetailsSection(section1);
        let section2 = employmentDetailsSection.map((item) => {
        item.value = insuredData.insuredEmploymentDetail[item.key];
        return item;
        });
        setEmploymentDetailsSection([...section2]);

        let section3 = permanentDetailsSection.map((item) => {
        if (["alterNateMobNumber", "mobileNumber", "email"].includes(item.key)) {
            item.value = insuredData.contactDetails[item.key];
        } else if (item.key === "sameAsPermanentAddress") {
            item.value = insuredData.contactDetails.sameAsPermanentAddress
            ? "YES"
            : "NO";
        } else {
            item.value = insuredData.contactDetails.permanentAddress[item.key];
        }
        return item;
        });
        setpermanentDetailsSection([...section3]);
        if (!insuredData.contactDetails.sameAsPermanentAddress) {
        let section4 = correspondenceAddressSection.map((item) => {
            item.value = insuredData.contactDetails.correspondenceAddress[item.key];
            return item;
        });
        setCorrespondenceAddressSection(section4);
        }
    }, [insuredData]);
    return (
        <div className="main_container">
        <ProposalList
            sectionLabel="Personal Details"
            initialdata={personalDetailsSection}
        />
        <ProposalList
            sectionLabel="Employment Details"
            initialdata={employmentDetailsSection}
        />
        <ProposalList
            sectionLabel="Permanent Address"
            initialdata={permanentDetailsSection}
        />
        <ProposalList
            sectionLabel="Correspondence Address"
            initialdata={correspondenceAddressSection}
        />
        </div>
    );
};

export default InsuredDetails;
